import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-send-message-item',
  templateUrl: './send-message-item.component.html',
  styleUrls: ['./send-message-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SendMessageItemComponent {

  @Input() isDisabled: boolean = false;

  @Input() message: string = '';
  @Output() messageChange: EventEmitter<string> = new EventEmitter<string>;

  @Output() attachFile: EventEmitter<File> = new EventEmitter<File>;
  @Output() sendMessage: EventEmitter<void> = new EventEmitter<void>;


  /**
   * Adjuntar documento
   *
   */
  attachFileAction(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    this.attachFile.emit(input.files[0])
  }


  /**
   * Adjuntar documento
   *
   */
  sendMessageAction() {

    if (!this.message || this.message.trim() === '') {
      return;
    }

    this.messageChange.emit(this.message);
    this.sendMessage.emit();

    this.clearMessage();
  }


  /**
   * Vaciar mensaje
   *
   */
  clearMessage() {
    this.message = '';
    this.messageChange.emit(this.message);
  }

}
